type UserCellProps = { name?: string; email?: string }

// A row with no recorded user (written before attribution, or by a system caller) leaves the cell blank.
export const UserCell = ({ name, email }: UserCellProps) => (
  <div>
    <div>{name}</div>
    <small className="text-muted">{email}</small>
  </div>
)
